import { Notification } from '@salecycle/ui-component-library';
import { FC } from 'react';
import { _closeNotification, useNotificationsDispatch, useNotificationsState } from './useNotificationsContext';

export const Notifications: FC = () => {
  const { delay, detailsText, text, variation, visible } = useNotificationsState();
  const dispatch = useNotificationsDispatch();

  const handleOnChange = (isOpen: boolean) => {
    if (!isOpen) {
      _closeNotification(dispatch);
    }
  };

  return (
    <Notification
      isOpen={visible}
      variation={variation}
      onChange={handleOnChange}
      delay={delay}
      collapsible={!!detailsText}
      collapsed={true}
      collapsibleDescription={detailsText ?? ''}
    >
      {text}
    </Notification>
  );
};

export default Notifications;
